module.exports = __webpack_public_path__ + "images/services/github.a2f718b1b462aebc473b.png";